/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Delete_Account_Code_InvalidInputs */

const en_delete_account_code_invalid = /** @type {(inputs: Delete_Account_Code_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verification code is invalid.`)
};

const es_delete_account_code_invalid = /** @type {(inputs: Delete_Account_Code_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El código de verificación no es válido.`)
};

const ar_delete_account_code_invalid = /** @type {(inputs: Delete_Account_Code_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`رمز التحقق غير صالح.`)
};

/**
* | output |
* | --- |
* | "Verification code is invalid." |
*
* @param {Delete_Account_Code_InvalidInputs} inputs
* @param {{ locale?: "en" | "es" | "ar" }} options
* @returns {LocalizedString}
*/
export const delete_account_code_invalid = /** @type {((inputs?: Delete_Account_Code_InvalidInputs, options?: { locale?: "en" | "es" | "ar" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Delete_Account_Code_InvalidInputs, { locale?: "en" | "es" | "ar" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_delete_account_code_invalid(inputs)
	if (locale === "es") return es_delete_account_code_invalid(inputs)
	return ar_delete_account_code_invalid(inputs)
});